import app from 'flarum/common/app';

app.initializers.add('maisen20/chatgpt-textenhancer', () => {
  console.log('[maisen20/chatgpt-textenhancer] Hello, forum and admin!');
});
